const selectFollowUps = (state) => state.followUpAgenciamento.list;
const selectFollowUp = (state) => state.followUpAgenciamento.model;
const selectRelatedDuplicataModel = (state) => (
  state.followUpAgenciamento.related.model.duplicata
);
const selectRelatedEmailModel = (state) => (
  state.followUpAgenciamento.related.model.email
);

const selectHistoryModel = (state) => state.followUpAgenciamento.historyModel;
const selectStatus = (state) => state.followUpAgenciamento.status;
const selectRefresh = (state) => state.followUpAgenciamento.refresh;
const selectMode = (state) => state.followUpAgenciamento.mode.main;
const selectBackgroundMode = (state) => state.followUpAgenciamento.mode.background;
const selectSubMode = (state) => state.followUpAgenciamento.mode.sub;
const selectConfigControl = (state) => state.followUpAgenciamento.config.control;
const selectError = (state) => state.followUpAgenciamento.error;
const selectResponse = (state) => state.followUpAgenciamento.response;
const selectAlreadyCreated = (state) => (
  state.followUpAgenciamento.related.model.alreadyCreated
);

const selectOperationMode = (state) => state.followUpAgenciamento.operation;

const followUpAgenciamentoSelectors = {
  selectFollowUps,
  selectFollowUp,
  selectRelatedDuplicataModel,
  selectRelatedEmailModel,
  selectHistoryModel,
  selectStatus,
  selectRefresh,
  selectMode,
  selectBackgroundMode,
  selectSubMode,
  selectConfigControl,
  selectError,
  selectResponse,
  selectAlreadyCreated,
  selectOperationMode,
};

export default followUpAgenciamentoSelectors;
